// extracted by mini-css-extract-plugin
module.exports = {"container":"data-layer-menu_container__BdvFa","tabBarContainer":"data-layer-menu_tabBarContainer__ud5kM"};